export const RELEASE_PROMPTS_LOCAL_STORAGE_KEY = `ReleasePrompts`;

export type ReleasePromptData = {
  route?: string;
  enabled: boolean;
  expiration?: Date;
  title: string;
  promptId: number;
  code: string;
  skipMobile?: boolean;
  action?: () => void;
};

export type PromptStatus = 'navigated' | 'deferred' | 'skipped';

export interface PromptState {
  status: PromptStatus;
  timestamp: string; // ISO timestamp
}

export interface PromptStates {
  promptsDisabled?: boolean;
  states: Record<number, PromptState>;
}
